<script setup>
import { ref, computed, onBeforeUnmount, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useGroupsAttrsStore } from '@/stores/groups-attrs'
import { useCarUsersGroupsStore } from '@/stores/car-users-groups'

function changePage(cursor, dir) {

    const params = {
        'c.limit': 12, 
        'c.direction': dir, 
        'c.cursor': cursor
    }

    carUsersGroupsStore.readCarUsersGroupsList(params).then(result => {
        if(result.array) {
            dir == 'after' ? 
                pageNumber.value++ : 
                pageNumber.value--
        }
    })
}

function showAttributes(event) {
    event.currentTarget.parentElement.classList.toggle('attrs-shown')
}

function submitForm(event) {

    const fields = event.target.getElementsByTagName("input")

    let data = {
        attr: {
            array: []
        },
        car: fields.car.value,
        ugroup: fields.ugroup.value
    }

    for(let field of fields) {
        if(field.type == 'checkbox' && field.checked) {
            if(field.name == 'navi')        data.attr.array.push(...attrsNavi.value)
            if(field.name == 'remote')      data.attr.array.push(...attrsRemote.value)
            if(field.name == 'diagnostic')  data.attr.array.push(...attrsDiagnostic.value)
            if(field.name == 'developer')   data.attr.array.push(...attrsDeveloper.value)
        }
    }

    carUsersGroupsStore.createCarUsersGroups(data)
}

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore       = useTranslaterStore()
const groupsAttrsStore      = useGroupsAttrsStore()
const carUsersGroupsStore   = useCarUsersGroupsStore()

const getTranslate                      = computed(() => translaterStore.getTranslate)
const attrsNavi                         = computed(() => groupsAttrsStore.navi)
const attrsRemote                       = computed(() => groupsAttrsStore.remote)
const attrsDiagnostic                   = computed(() => groupsAttrsStore.diagnostic)
const attrsDeveloper                    = computed(() => groupsAttrsStore.developer)
const carUsersGroupsCreateList          = computed(() => carUsersGroupsStore.carUsersGroupsCreateList)
const carUsersGroupsCreateListProcess   = computed(() => carUsersGroupsStore.carUsersGroupsCreateListProcess)
const carUsersGroupsCreateListMsg       = computed(() => carUsersGroupsStore.carUsersGroupsCreateListMsg)
const carUsersGroupsCreateProcess       = computed(() => carUsersGroupsStore.carUsersGroupsCreateProcess)
const carUsersGroupsCreateMsg            = computed(() => carUsersGroupsStore.carUsersGroupsCreateMsg)

const inputSearch = ref('')
const pageNumber = ref(1)

carUsersGroupsStore.readCarUsersGroupsList({ 'c.limit': 6 })

onBeforeUnmount(() => {

    carUsersGroupsStore.setCarUsersGroupsCreateMsg({})
})

watch(inputSearch, input => {
    input.length > 2 ? 
        carUsersGroupsStore.readCarUsersGroupsList({ 'c.limit': 6, 'c.q': input }) :
        carUsersGroupsStore.readCarUsersGroupsList({ 'c.limit': 6 })
})
</script>

<template>
    <div class="uta-users-group-cars-group-create">

        <div class="row mb-4 justify-content-between">
            <div class="col-12">
                <div class="uta-input__wrapper uta-search">
                    <input 
                        type="text" 
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = ''"
                        class="form-control uta-input__wrapper-input uta-search__input uta-search__input--light" 
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = ''">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div 
            v-if="
                'success' in carUsersGroupsCreateListMsg && 
                !carUsersGroupsCreateListMsg.success
            "
            class="my-4 uta-alert uta-alert--success"
        >
            <span class="material-icons uta-alert__icon">check_circle_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersGroupsCreateListMsg.text] || carUsersGroupsCreateListMsg.text }}
            </div>
        </div>

        <div 
            v-if="'success' in carUsersGroupsCreateMsg"
            class="my-4 uta-alert"
            :class="{
                'uta-alert--success' : carUsersGroupsCreateMsg.success, 
                'uta-alert--danger' : !carUsersGroupsCreateMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ carUsersGroupsCreateMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersGroupsCreateMsg.text] || carUsersGroupsCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carUsersGroupsStore.setCarUsersGroupsCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div v-if="carUsersGroupsCreateList.array?.length">

            <div class="mb-4 uta-list uta-users-group-cars-group-create__list">
                <form
                    action="" 
                    class="uta-users-group-cars-group-create__item align-items-center uta-list__item row"
                    v-for="(group, index) in carUsersGroupsCreateList.array"
                    :key="index"
                    @submit.prevent="submitForm($event)" 
                >
                    <div class="col-10 col-sm-11 uta-users-group-cars-group-create__name" @click="showAttributes($event)">
                        <a href="#" class="uta-list__item-link uta-users-group-cars-group-create__name">
                            {{ group.name }}
                        </a>
                    </div>
                    <div class="col-2 col-sm-1 text-end uta-users-group-cars-group-create__attrs-ctrl" @click="showAttributes($event)">
                        <span class="material-icons">
                            expand_more
                        </span>
                    </div>
                    <div class="col-24 pt-3 uta-users-group-cars-group-create__attrs">

                        <!-- Навигационная информация -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="navi"
                                class="form-check-input uta-users-group-cars__attrs-attr" 
                                :id="'users-group-cars-attr_navi-' + group.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_navi-' + group.uuid"
                            >
                                {{ getTranslate.ATTR_GEODATA }}
                            </label>
                        </div>

                        <!-- Удаленное управление -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="remote"
                                class="form-check-input uta-users-group-cars__attrs-attr" 
                                :id="'users-group-cars-attr_remote-' + group.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_remote-' + group.uuid"
                            >
                                {{ getTranslate.ATTR_REMOTE_CONTROL }}
                            </label>
                        </div>

                        <!-- Диагностика -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="diagnostic"
                                class="form-check-input uta-users-group-cars__attrs-attr" 
                                :id="'users-group-cars-attr_diagnostic-' + group.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_diagnostic-' + group.uuid"
                            >
                                {{ getTranslate.ATTR_DIAGNOSTIC }}
                            </label>
                        </div>

                        <!-- Режим разработчика -->
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                name="developer"
                                class="form-check-input uta-users-group-cars__attrs-attr" 
                                :id="'users-group-cars-attr_developer-' + group.uuid"
                            > 
                            <label 
                                class="form-check-label" 
                                :for="'users-group-cars-attr_developer-' + group.uuid"
                            >
                                {{ getTranslate.ATTRS_DEVELOPER }}
                            </label>
                        </div>

                        <button type="submit" :disabled="carUsersGroupsCreateProcess" class="uta-btn uta-btn--main mt-3">
                            <template v-if="!carUsersGroupsCreateProcess">
                                {{ getTranslate.BTN_ADD }}
                            </template>
                            <template v-else>
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </template>
                        </button>
                    </div>
                    <input type="hidden" name="ugroup" :value="group.uuid">
                    <input type="hidden" name="car" :value="props.uuid">
                </form>
            </div>

            <div class="uta-cars__pagination" v-if="carUsersGroupsCreateList.c && (carUsersGroupsCreateList.c.isBefore || carUsersGroupsCreateList.c.isAfter)">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="uta-pagination">
                            <button 
                                :disabled="carUsersGroupsCreateListProcess || !carUsersGroupsCreateList.c.isBefore"
                                class="uta-btn uta-btn--sm uta-pagination__prev" 
                                @click.prevent="changePage(carUsersGroupsCreateList.c.start, 'before')"
                            >
                                <span class="material-icons">
                                    navigate_before
                                </span>
                            </button>
                            <div class="uta-pagination__current">
                                {{ pageNumber }}
                            </div>
                            <button 
                                :disabled="carUsersGroupsCreateListProcess || !carUsersGroupsCreateList.c.isAfter"
                                class="uta-btn uta-btn--sm uta-pagination__next" 
                                @click.prevent="changePage(carUsersGroupsCreateList.c.stop, 'after')"
                            >
                                <span class="material-icons">
                                    navigate_next
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/users-group-cars-group-create';
</style>